function webRtcPlayer(parOptions) {
    parOptions = typeof parOptions !== "undefined" ? parOptions : {};
    var self = this;
    const urlParams = new URLSearchParams(window.location.search);
    this.cfg = typeof parOptions.peerConnectionOptions !== "undefined" ? parOptions.peerConnectionOptions : {};
    this.cfg.sdpSemantics = "unified-plan";
    this.cfg.offerExtmapAllowMixed = false;
    this.forceTURN = urlParams.has("ForceTURN");
    if (this.forceTURN) {
        this.cfg.iceTransportPolicy = "relay";
    }
    this.cfg.bundlePolicy = "balanced";
    this.forceMaxBundle = urlParams.has("ForceMaxBundle");
    if (this.forceMaxBundle) {
        this.cfg.bundlePolicy = "max-bundle";
    }
    this.pcClient = null;
    this.dcClient = null;
    this.tnClient = null;
    this.sdpConstraints = { offerToReceiveAudio: 1, offerToReceiveVideo: 1, voiceActivityDetection: false };
    this.dataChannelOptions = { ordered: true };
    this.startVideoMuted = typeof parOptions.startVideoMuted !== "undefined" ? parOptions.startVideoMuted : false;
    this.autoPlayAudio = typeof parOptions.autoPlayAudio !== "undefined" ? parOptions.autoPlayAudio : true;
    this.forceMonoAudio = urlParams.has("ForceMonoAudio");
    if (this.forceMonoAudio) {
    }
    this.useMic = urlParams.has("useMic");
    if (!this.useMic) {
    }
    let isLocalhostConnection = location.hostname === "localhost" || location.hostname === "127.0.0.1";
    let isHttpsConnection = location.protocol === "https:";
    if (this.useMic && !isLocalhostConnection && !isHttpsConnection) {
        this.useMic = false;
        console.error("Microphone access in the browser will not work if you are not on HTTPS or localhost. Disabling mic access.");
        console.error("For testing you can enable HTTP microphone access Chrome by visiting chrome://flags/ and enabling 'unsafely-treat-insecure-origin-as-secure'");
    }
    this.preferSFU = urlParams.has("preferSFU");
    this.latencyTestTimings = {
        TestStartTimeMs: null,
        UEReceiptTimeMs: null,
        UEEncodeMs: null,
        UECaptureToSendMs: null,
        UETransmissionTimeMs: null,
        BrowserReceiptTimeMs: null,
        FrameDisplayDeltaTimeMs: null,
        Reset: function () {
            this.TestStartTimeMs = null;
            this.UEReceiptTimeMs = null;
            (this.UEEncodeMs = null), (this.UECaptureToSendMs = null), (this.UETransmissionTimeMs = null);
            this.BrowserReceiptTimeMs = null;
            this.FrameDisplayDeltaTimeMs = null;
        },
        SetUETimings: function (UETimings) {
            this.UEReceiptTimeMs = UETimings.ReceiptTimeMs;
            (this.UEEncodeMs = UETimings.EncodeMs), (this.UECaptureToSendMs = UETimings.CaptureToSendMs), (this.UETransmissionTimeMs = UETimings.TransmissionTimeMs);
            this.BrowserReceiptTimeMs = Date.now();
            this.OnAllLatencyTimingsReady(this);
        },
        SetFrameDisplayDeltaTime: function (DeltaTimeMs) {
            if (this.FrameDisplayDeltaTimeMs == null) {
                this.FrameDisplayDeltaTimeMs = Math.round(DeltaTimeMs);
                this.OnAllLatencyTimingsReady(this);
            }
        },
        OnAllLatencyTimingsReady: function (Timings) {},
    };
    this.uuid4 = function () {
        let temp_url = URL.createObjectURL(new Blob());
        let uuid = temp_url.toString();
        URL.revokeObjectURL(temp_url);
        return uuid.split(/[:/]/g).pop().toLowerCase();
    };
    this.createWebRtcVideo = function () {
        var video = document.createElement("video");
        video.id = "streamingVideo" + this.uuid4();
        video.class = "streamingVideo";
        video.playsInline = true;
        video.disablePictureInPicture = true;
        video.muted = self.startVideoMuted;
        video.muted = true;
        video.autoplay = true;
        video.addEventListener(
            "loadedmetadata",
            function (e) {
                if (self.onVideoInitialised) {
                    self.onVideoInitialised();
                }
            },
            true
        );
        if ("requestVideoFrameCallback" in HTMLVideoElement.prototype) {
            const onVideoFrameReady = (now, metadata) => {
                if (metadata.receiveTime && metadata.expectedDisplayTime) {
                    const receiveToCompositeMs = metadata.presentationTime - metadata.receiveTime;
                    if (self.aggregatedStats) {
                        self.aggregatedStats.receiveToCompositeMs = receiveToCompositeMs;
                    }
                }
                video.requestVideoFrameCallback(onVideoFrameReady);
            };
            video.requestVideoFrameCallback(onVideoFrameReady);
        }
        return video;
    };
    this.createWebRtcAudio = function () {
        let toggleElem = document.getElementById("streamingAudio");
        let audio = null;
        if (!toggleElem) {
            audio = document.createElement("audio");
            audio.id = "streamingAudio";
        } else {
            audio = toggleElem;
        }
        return audio;
    };
    this.video = this.createWebRtcVideo();
    this.audio = this.createWebRtcAudio();
    this.availableVideoStreams = new Map();
    var onsignalingstatechange = function (state) {};
    var oniceconnectionstatechange = function (state) {};
    var onicegatheringstatechange = function (state) {};
    var handleOnTrack = function (e) {
        if (e.track) {
        }
        if (e.track.kind == "audio") {
            handleOnAudioTrack(e.streams[0]);
            return;
        } else if (e.track.kind == "video") {
            for (const s of e.streams) {
                if (!self.availableVideoStreams.has(s.id)) {
                    self.availableVideoStreams.set(s.id, s);
                }
            }
            self.video.srcObject = e.streams[0];
            e.track.onunmute = () => {
                self.video.srcObject = e.streams[0];
                self.onNewVideoTrack(e.streams);
            };
        }
    };
    var handleOnAudioTrack = function (audioMediaStream) {
        if (self.video.srcObject == audioMediaStream) {
            return;
        } else if (self.video.srcObject && self.video.srcObject !== audioMediaStream) {
            self.audio.srcObject = audioMediaStream;
        }
    };
    var onDataChannel = function (dataChannelEvent) {
        self.dcClient = dataChannelEvent.channel;
        setupDataChannelCallbacks(self.dcClient);
    };
    var createDataChannel = function (pc, label, options) {
        let datachannel = pc.createDataChannel(label, options);
        setupDataChannelCallbacks(datachannel);
        return datachannel;
    };
    var setupDataChannelCallbacks = function (datachannel) {
        try {
            datachannel.binaryType = "arraybuffer";
            datachannel.onopen = function (e) {
                if (self.onDataChannelConnected) {
                    self.onDataChannelConnected();
                }
            };
            datachannel.onclose = function (e) {};
            datachannel.onmessage = function (e) {
                if (self.onDataChannelMessage) {
                    self.onDataChannelMessage(e.data);
                }
            };
            datachannel.onerror = function (e) {
                console.error("Data channel error", e);
            };
            return datachannel;
        } catch (e) {
            console.warn("No data channel", e);
            return null;
        }
    };
    var onicecandidate = function (e) {
        let candidate = e.candidate;
        if (candidate && candidate.candidate) {
            self.onWebRtcCandidate(candidate);
        }
    };
    var handleCreateOffer = function (pc) {
        pc.createOffer(self.sdpConstraints).then(
            function (offer) {
                mungeSDPOffer(offer);
                pc.setLocalDescription(offer);
                if (self.onWebRtcOffer) {
                    self.onWebRtcOffer(offer);
                }
            },
            function () {
                console.warn("Couldn't create offer");
            }
        );
    };
    var mungeSDPOffer = function (offer) {
        let audioSDP = "";
        audioSDP += "maxaveragebitrate=510000;";
        if (self.useMic) {
            audioSDP += "sprop-maxcapturerate=48000;";
        }
        audioSDP += self.forceMonoAudio ? "sprop-stereo=0;stereo=0;" : "sprop-stereo=1;stereo=1;";
        audioSDP += "useinbandfec=1";
        offer.sdp = offer.sdp.replace("useinbandfec=1", audioSDP);
    };
    var setupPeerConnection = function (pc) {
        pc.onsignalingstatechange = onsignalingstatechange;
        pc.oniceconnectionstatechange = oniceconnectionstatechange;
        pc.onicegatheringstatechange = onicegatheringstatechange;
        pc.ontrack = handleOnTrack;
        pc.onicecandidate = onicecandidate;
        pc.ondatachannel = onDataChannel;
    };
    var generateAggregatedStatsFunction = function () {
        if (!self.aggregatedStats) self.aggregatedStats = {};
        return function (stats) {
            let newStat = {};
            stats.forEach(stat => {
                if (stat.type == "inbound-rtp" && !stat.isRemote && (stat.mediaType == "video" || stat.id.toLowerCase().includes("video"))) {
                    newStat.timestamp = stat.timestamp;
                    newStat.bytesReceived = stat.bytesReceived;
                    newStat.framesDecoded = stat.framesDecoded;
                    newStat.packetsLost = stat.packetsLost;
                    newStat.bytesReceivedStart = self.aggregatedStats && self.aggregatedStats.bytesReceivedStart ? self.aggregatedStats.bytesReceivedStart : stat.bytesReceived;
                    newStat.framesDecodedStart = self.aggregatedStats && self.aggregatedStats.framesDecodedStart ? self.aggregatedStats.framesDecodedStart : stat.framesDecoded;
                    newStat.timestampStart = self.aggregatedStats && self.aggregatedStats.timestampStart ? self.aggregatedStats.timestampStart : stat.timestamp;
                    if (self.aggregatedStats && self.aggregatedStats.timestamp) {
                        if (self.aggregatedStats.bytesReceived) {
                            newStat.bitrate = (8 * (newStat.bytesReceived - self.aggregatedStats.bytesReceived)) / (newStat.timestamp - self.aggregatedStats.timestamp);
                            newStat.bitrate = Math.floor(newStat.bitrate);
                            newStat.lowBitrate = self.aggregatedStats.lowBitrate && self.aggregatedStats.lowBitrate < newStat.bitrate ? self.aggregatedStats.lowBitrate : newStat.bitrate;
                            newStat.highBitrate = self.aggregatedStats.highBitrate && self.aggregatedStats.highBitrate > newStat.bitrate ? self.aggregatedStats.highBitrate : newStat.bitrate;
                        }
                        if (self.aggregatedStats.bytesReceivedStart) {
                            newStat.avgBitrate = (8 * (newStat.bytesReceived - self.aggregatedStats.bytesReceivedStart)) / (newStat.timestamp - self.aggregatedStats.timestampStart);
                            newStat.avgBitrate = Math.floor(newStat.avgBitrate);
                        }
                        if (self.aggregatedStats.framesDecoded) {
                            newStat.framerate = (newStat.framesDecoded - self.aggregatedStats.framesDecoded) / ((newStat.timestamp - self.aggregatedStats.timestamp) / 1e3);
                            newStat.framerate = Math.floor(newStat.framerate);
                            newStat.lowFramerate = self.aggregatedStats.lowFramerate && self.aggregatedStats.lowFramerate < newStat.framerate ? self.aggregatedStats.lowFramerate : newStat.framerate;
                            newStat.highFramerate = self.aggregatedStats.highFramerate && self.aggregatedStats.highFramerate > newStat.framerate ? self.aggregatedStats.highFramerate : newStat.framerate;
                        }
                        if (self.aggregatedStats.framesDecodedStart) {
                            newStat.avgframerate = (newStat.framesDecoded - self.aggregatedStats.framesDecodedStart) / ((newStat.timestamp - self.aggregatedStats.timestampStart) / 1e3);
                            newStat.avgframerate = Math.floor(newStat.avgframerate);
                        }
                    }
                }
                if (stat.type == "track" && (stat.trackIdentifier == "video_label" || stat.kind == "video")) {
                    newStat.framesDropped = stat.framesDropped;
                    newStat.framesReceived = stat.framesReceived;
                    newStat.framesDroppedPercentage = (stat.framesDropped / stat.framesReceived) * 100;
                    newStat.frameHeight = stat.frameHeight;
                    newStat.frameWidth = stat.frameWidth;
                    newStat.frameHeightStart = self.aggregatedStats && self.aggregatedStats.frameHeightStart ? self.aggregatedStats.frameHeightStart : stat.frameHeight;
                    newStat.frameWidthStart = self.aggregatedStats && self.aggregatedStats.frameWidthStart ? self.aggregatedStats.frameWidthStart : stat.frameWidth;
                }
                if (stat.type == "candidate-pair" && stat.hasOwnProperty("currentRoundTripTime") && stat.currentRoundTripTime != 0) {
                    newStat.currentRoundTripTime = stat.currentRoundTripTime;
                }
            });
            if (self.aggregatedStats.receiveToCompositeMs) {
                newStat.receiveToCompositeMs = self.aggregatedStats.receiveToCompositeMs;
                self.latencyTestTimings.SetFrameDisplayDeltaTime(self.aggregatedStats.receiveToCompositeMs);
            }
            self.aggregatedStats = newStat;
            if (self.onAggregatedStats) self.onAggregatedStats(newStat);
        };
    };
    var setupTransceiversAsync = async function (pc) {
        let hasTransceivers = pc.getTransceivers().length > 0;
        pc.addTransceiver("video", { direction: "recvonly" });
        if (!self.useMic) {
            pc.addTransceiver("audio", { direction: "recvonly" });
        } else {
            let audioSendOptions = self.useMic ? { autoGainControl: false, channelCount: 1, echoCancellation: false, latency: 0, noiseSuppression: false, sampleRate: 48e3, volume: 1 } : false;
            const stream = await navigator.mediaDevices.getUserMedia({ video: false, audio: audioSendOptions });
            if (stream) {
                if (hasTransceivers) {
                    for (let transceiver of pc.getTransceivers()) {
                        if (transceiver && transceiver.receiver && transceiver.receiver.track && transceiver.receiver.track.kind === "audio") {
                            for (const track of stream.getTracks()) {
                                if (track.kind && track.kind == "audio") {
                                    transceiver.sender.replaceTrack(track);
                                    transceiver.direction = "sendrecv";
                                }
                            }
                        }
                    }
                } else {
                    for (const track of stream.getTracks()) {
                        if (track.kind && track.kind == "audio") {
                            pc.addTransceiver(track, { direction: "sendrecv" });
                        }
                    }
                }
            } else {
                pc.addTransceiver("audio", { direction: "recvonly" });
            }
        }
    };
    this.setVideoEnabled = function (enabled) {
        self.video.srcObject.getTracks().forEach(track => (track.enabled = enabled));
    };
    this.startLatencyTest = function (onTestStarted) {
        if (!self.video) {
            return;
        }
        self.latencyTestTimings.Reset();
        self.latencyTestTimings.TestStartTimeMs = Date.now();
        onTestStarted(self.latencyTestTimings.TestStartTimeMs);
    };
    this.handleCandidateFromServer = function (iceCandidate) {
        let candidate = new RTCIceCandidate(iceCandidate);
        if (self.forceTURN) {
            if (candidate.candidate.indexOf("relay") < 0) {
                console.warn("Dropping candidate because it was not TURN relay.", "| Type=", candidate.type, "| Protocol=", candidate.protocol, "| Address=", candidate.address, "| Port=", candidate.port, "|");
                return;
            }
        }
        self.pcClient.addIceCandidate(candidate).catch(function (e) {
            console.error("Failed to add ICE candidate", e);
        });
    };
    this.createOffer = function () {
        if (self.pcClient) {
            self.pcClient.close();
            self.pcClient = null;
        }
        self.pcClient = new RTCPeerConnection(self.cfg);
        setupPeerConnection(self.pcClient);
        setupTransceiversAsync(self.pcClient).finally(function () {
            self.dcClient = createDataChannel(self.pcClient, "cirrus", self.dataChannelOptions);
            handleCreateOffer(self.pcClient);
        });
    };
    this.receiveOffer = function (offer) {
        var offerDesc = new RTCSessionDescription(offer);
        if (!self.pcClient) {
            self.pcClient = new RTCPeerConnection(self.cfg);
            setupPeerConnection(self.pcClient);
            self.pcClient.setRemoteDescription(offerDesc).then(() => {
                setupTransceiversAsync(self.pcClient).finally(function () {
                    self.pcClient
                        .createAnswer()
                        .then(answer => {
                            mungeSDPOffer(answer);
                            return self.pcClient.setLocalDescription(answer);
                        })
                        .then(() => {
                            if (self.onWebRtcAnswer) {
                                self.onWebRtcAnswer(self.pcClient.currentLocalDescription);
                            }
                        })
                        .then(() => {
                            let receivers = self.pcClient.getReceivers();
                            for (let receiver of receivers) {
                                receiver.playoutDelayHint = 0;
                            }
                        })
                        .catch(error => console.error("createAnswer() failed:", error));
                });
            });
        }
    };
    this.receiveAnswer = function (answer) {
        var answerDesc = new RTCSessionDescription(answer);
        self.pcClient.setRemoteDescription(answerDesc);
        let receivers = self.pcClient.getReceivers();
        for (let receiver of receivers) {
            receiver.playoutDelayHint = 0;
        }
    };
    this.close = function () {
        if (self.pcClient) {
            self.pcClient.close();
            self.pcClient = null;
        }
        if (self.aggregateStatsIntervalId) clearInterval(self.aggregateStatsIntervalId);
    };
    this.send = function (data) {
        if (self.dcClient && self.dcClient.readyState == "open") {
            self.dcClient.send(data);
        }
    };
    this.getStats = function (onStats) {
        if (self.pcClient && onStats) {
            self.pcClient.getStats(null).then(stats => {
                onStats(stats);
            });
        }
    };
    this.aggregateStats = function (checkInterval) {
        let calcAggregatedStats = generateAggregatedStatsFunction();
        let printAggregatedStats = () => {
            self.getStats(calcAggregatedStats);
        };
        self.aggregateStatsIntervalId = setInterval(printAggregatedStats, checkInterval);
    };
}
let haveEvents = "GamepadEvent" in window;
let haveWebkitEvents = "WebKitGamepadEvent" in window;
let controllers = {};
let rAF = window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.requestAnimationFrame;
let kbEvent = document.createEvent("KeyboardEvent");
let webRtcPlayerObj = null;
let print_stats = false;
let print_inputs = false;
let connect_on_load = true;
let is_reconnection = false;
let ws;
const WS_OPEN_STATE = 1;
let autoPlayAudio = true;
let qualityController = false;
let qualityControlOwnershipCheckBox;
let matchViewportResolution = true;
let lastTimeResized = new Date().getTime();
let resizeTimeout;
let responseEventListeners = new Map();
let freezeFrameOverlay = null;
let shouldShowPlayOverlay = true;
let freezeFrame = { receiving: false, size: 0, jpeg: undefined, height: 0, width: 0, valid: false };
let file = { mimetype: "", extension: "", receiving: false, size: 0, data: [], valid: false, timestampStart: undefined };
let afk = { enabled: false, warnTimeout: 120, closeTimeout: 10, active: false, overlay: undefined, warnTimer: undefined, countdown: 0, countdownTimer: undefined };
let editTextButton = undefined;
let hiddenInput = undefined;
let t0 = Date.now();
let activeKeys = [];
function log(str) {
    console.log(`${Math.floor(Date.now() - t0)}: ` + str);
}
function scanGamepads() {
    let gamepads = navigator.getGamepads ? navigator.getGamepads() : navigator.webkitGetGamepads ? navigator.webkitGetGamepads() : [];
    for (let i = 0; i < gamepads.length; i++) {
        if (gamepads[i] && gamepads[i].index in controllers) {
            controllers[gamepads[i].index].currentState = gamepads[i];
        }
    }
}
function updateStatus() {
    scanGamepads();
    for (j in controllers) {
        let controller = controllers[j];
        let currentState = controller.currentState;
        let prevState = controller.prevState;
        for (let i = 0; i < currentState.buttons.length; i++) {
            let currButton = currentState.buttons[i];
            let prevButton = prevState.buttons[i];
            if (currButton.pressed && !prevButton.pressed) {
                if (i == 6) {
                    emitControllerAxisMove(j, 5, currButton.value);
                } else if (i == 7) {
                    emitControllerAxisMove(j, 6, currButton.value);
                } else {
                    emitControllerButtonPressed(j, i, 0);
                }
            } else if (!currButton.pressed && prevButton.pressed) {
                if (i == 6) {
                    emitControllerAxisMove(j, 5, 0);
                } else if (i == 7) {
                    emitControllerAxisMove(j, 6, 0);
                } else {
                    emitControllerButtonReleased(j, i);
                }
            } else if (currButton.pressed && prevButton.pressed) {
                if (i == 6) {
                    emitControllerAxisMove(j, 5, currButton.value);
                } else if (i == 7) {
                    emitControllerAxisMove(j, 6, currButton.value);
                } else {
                    emitControllerButtonPressed(j, i, 1);
                }
            }
        }
        for (let i = 0; i < currentState.axes.length; i += 2) {
            let x = parseFloat(currentState.axes[i].toFixed(4));
            let y = -parseFloat(currentState.axes[i + 1].toFixed(4));
            if (i === 0) {
                emitControllerAxisMove(j, 1, x);
                emitControllerAxisMove(j, 2, y);
            } else if (i === 2) {
                emitControllerAxisMove(j, 3, x);
                emitControllerAxisMove(j, 4, y);
            }
        }
        controllers[j].prevState = currentState;
    }
    rAF(updateStatus);
}
function emitControllerButtonPressed(controllerIndex, buttonIndex, isRepeat) {
    Data = new DataView(new ArrayBuffer(4));
    Data.setUint8(0, MessageType.GamepadButtonPressed);
    Data.setUint8(1, controllerIndex);
    Data.setUint8(2, buttonIndex);
    Data.setUint8(3, isRepeat);
}
function emitControllerButtonReleased(controllerIndex, buttonIndex) {
    Data = new DataView(new ArrayBuffer(3));
    Data.setUint8(0, MessageType.GamepadButtonReleased);
    Data.setUint8(1, controllerIndex);
    Data.setUint8(2, buttonIndex);
}
function emitControllerAxisMove(controllerIndex, axisIndex, analogValue) {
    Data = new DataView(new ArrayBuffer(11));
    Data.setUint8(0, MessageType.GamepadAnalog);
    Data.setUint8(1, controllerIndex);
    Data.setUint8(2, axisIndex);
    Data.setFloat64(3, analogValue, true);
    sendInputData(Data.buffer);
}
function gamepadConnectHandler(e) {
    console.log("Gamepad connect handler");
    gamepad = e.gamepad;
    controllers[gamepad.index] = {};
    controllers[gamepad.index].currentState = gamepad;
    controllers[gamepad.index].prevState = gamepad;
    console.log("gamepad: " + gamepad.id + " connected");
    rAF(updateStatus);
}
function gamepadDisconnectHandler(e) {
    console.log("Gamepad disconnect handler");
    console.log("gamepad: " + e.gamepad.id + " disconnected");
    delete controllers[e.gamepad.index];
}
function setupHtmlEvents() {
    window.addEventListener("resize", resizePlayerStyle, true);
    window.addEventListener("orientationchange", onOrientationChange);
    if (haveEvents) {
        window.addEventListener("gamepadconnected", gamepadConnectHandler);
        window.addEventListener("gamepaddisconnected", gamepadDisconnectHandler);
    } else if (haveWebkitEvents) {
        window.addEventListener("webkitgamepadconnected", gamepadConnectHandler);
        window.addEventListener("webkitgamepaddisconnected", gamepadDisconnectHandler);
    }
    let resizeCheckBox = document.getElementById("enlarge-display-to-fill-window-tgl");
    if (resizeCheckBox !== null) {
        resizeCheckBox.onchange = function (event) {
            resizePlayerStyle();
        };
    }
    qualityControlOwnershipCheckBox = document.getElementById("quality-control-ownership-tgl");
    if (qualityControlOwnershipCheckBox !== null) {
        qualityControlOwnershipCheckBox.onchange = function (event) {
            requestQualityControl();
        };
    }
    let encoderParamsSubmit = document.getElementById("encoder-params-submit");
    if (encoderParamsSubmit !== null) {
        encoderParamsSubmit.onclick = function (event) {
            let minQP = document.getElementById("encoder-min-qp-text").value;
            let maxQP = document.getElementById("encoder-max-qp-text").value;
            emitCommand({ ConsoleCommand: "PixelStreaming.Encoder.MinQP " + minQP });
            emitCommand({ ConsoleCommand: "PixelStreaming.Encoder.MaxQP " + maxQP });
        };
    }
    let webrtcParamsSubmit = document.getElementById("webrtc-params-submit");
    if (webrtcParamsSubmit !== null) {
        webrtcParamsSubmit.onclick = function (event) {
            let FPS = document.getElementById("webrtc-fps-text").value;
            let minBitrate = document.getElementById("webrtc-min-bitrate-text").value * 1e3;
            let maxBitrate = document.getElementById("webrtc-max-bitrate-text").value * 1e3;
            emitCommand({ ConsoleCommand: "PixelStreaming.WebRTC.Fps " + FPS });
            emitCommand({ ConsoleCommand: "PixelStreaming.WebRTC.MinBitrate " + minBitrate });
            emitCommand({ ConsoleCommand: "PixelStreaming.WebRTC.MaxBitrate " + maxBitrate });
        };
    }
    let showFPSButton = document.getElementById("show-fps-button");
    if (showFPSButton !== null) {
        showFPSButton.onclick = function (event) {
            let consoleDescriptor = { ConsoleCommand: "Stat FPS" };
            emitCommand(consoleDescriptor);
        };
    }
    let matchViewportResolutionCheckBox = document.getElementById("match-viewport-res-tgl");
    if (matchViewportResolutionCheckBox !== null) {
        matchViewportResolutionCheckBox.onchange = function (event) {
            matchViewportResolution = matchViewportResolutionCheckBox.checked;
        };
    }
    let statsCheckBox = document.getElementById("show-stats-tgl");
    if (statsCheckBox !== null) {
        statsCheckBox.onchange = function (event) {
            let stats = document.getElementById("statsContainer");
            stats.style.display = event.target.checked ? "block" : "none";
        };
    }
    let latencyButton = document.getElementById("test-latency-button");
    if (latencyButton) {
        latencyButton.onclick = () => {
            sendStartLatencyTest();
        };
    }
    setupToggleWithUrlParams("prefer-sfu-tgl", "preferSFU");
    setupToggleWithUrlParams("use-mic-tgl", "useMic");
    setupToggleWithUrlParams("force-turn-tgl", "ForceTURN");
    setupToggleWithUrlParams("force-mono-tgl", "ForceMonoAudio");
    var streamSelector = document.getElementById("stream-select");
    var trackSelector = document.getElementById("track-select");
    if (streamSelector) {
        streamSelector.onchange = function (event) {
            const stream = webRtcPlayerObj.availableVideoStreams.get(streamSelector.value);
            webRtcPlayerObj.video.srcObject = stream;
            streamTrackSource = stream;
            webRtcPlayerObj.video.play();
            updateTrackList();
        };
        if (trackSelector) {
            trackSelector.onchange = function (event) {
                if (!streamTrackSource) {
                    streamTrackSource = webRtcPlayerObj.availableVideoStreams.get(streamSelector.value);
                }
                if (streamTrackSource) {
                    for (const track of streamTrackSource.getVideoTracks()) {
                        if (track.id == trackSelector.value) {
                            webRtcPlayerObj.video.srcObject = new MediaStream([track]);
                            webRtcPlayerObj.video.play();
                            streamSelector.value = "";
                            break;
                        }
                    }
                }
            };
        }
    }
}
function setupToggleWithUrlParams(toggleId, urlParameterKey) {
    let toggleElem = document.getElementById(toggleId);
    if (toggleElem) {
        toggleElem.checked = new URLSearchParams(window.location.search).has(urlParameterKey);
        toggleElem.addEventListener("change", event => {
            const urlParams = new URLSearchParams(window.location.search);
            if (event.currentTarget.checked) {
                urlParams.set(urlParameterKey, "true");
            } else {
                urlParams.delete(urlParameterKey);
            }
            window.history.replaceState({}, "", urlParams.toString() !== "" ? `${location.pathname}?${urlParams}` : `${location.pathname}`);
        });
    }
}
var streamTrackSource = null;
function updateStreamList() {
    const streamSelector = document.getElementById("stream-select");
    for (i = streamSelector.options.length - 1; i >= 0; i--) {
        streamSelector.remove(i);
    }
    streamSelector.value = null;
    for (const [streamId, stream] of webRtcPlayerObj.availableVideoStreams) {
        var opt = document.createElement("option");
        opt.value = streamId;
        opt.innerHTML = streamId;
        streamSelector.appendChild(opt);
        if (streamSelector.value == null) {
            streamSelector.value = streamId;
        }
    }
    updateTrackList();
}
function updateTrackList() {
    const streamSelector = document.getElementById("stream-select");
    const trackSelector = document.getElementById("track-select");
    const stream = webRtcPlayerObj.availableVideoStreams.get(streamSelector.value);
    for (i = trackSelector.options.length - 1; i >= 0; i--) {
        trackSelector.remove(i);
    }
    trackSelector.value = null;
    for (const track of stream.getVideoTracks()) {
        var opt = document.createElement("option");
        opt.value = track.id;
        opt.innerHTML = track.label;
        trackSelector.appendChild(opt);
        if (track.selected) {
            trackSelector.value = track.id;
        }
    }
}
function sendStartLatencyTest() {
    if (!webRtcPlayerObj) {
        return;
    }
    let onTestStarted = function (StartTimeMs) {
        let descriptor = { StartTime: StartTimeMs };
        emitDescriptor(MessageType.LatencyTest, descriptor);
    };
    webRtcPlayerObj.startLatencyTest(onTestStarted);
}
function setOverlay(htmlClass, htmlElement, onClickFunction) {}
function showConnectOverlay() {
    let startText = document.createElement("div");
    startText.id = "playButton";
    setOverlay("clickableState", startText, event => {
        connect();
        startAfkWarningTimer();
    });
}
function showTextOverlay(text) {
    let textOverlay = document.createElement("div");
    textOverlay.id = "messageOverlay";
    textOverlay.innerHTML = text ? text : "";
    setOverlay("textDisplayState", textOverlay);
}
function playStream() {
    if (webRtcPlayerObj && webRtcPlayerObj.video) {
        if (webRtcPlayerObj.audio.srcObject && autoPlayAudio) {
            webRtcPlayerObj.video.muted = true;
            webRtcPlayerObj.audio
                .play()
                .then(() => {
                    playVideo();
                })
                .catch(onRejectedReason => {
                    console.warn(onRejectedReason);
                    console.log("Browser does not support autoplaying audio without interaction - to resolve this we are going to show the play button overlay.");
                });
        } else {
            playVideo();
        }
        requestInitialSettings();
        requestQualityControl();
        showFreezeFrameOverlay();
        hideOverlay();
    } else {
        console.warn("Could not player video stream because webRtcPlayerObj.video was not valid.");
    }
}
function playVideo() {
    webRtcPlayerObj.video.play().catch(onRejectedReason => {
        if (webRtcPlayerObj.audio.srcObject) {
            webRtcPlayerObj.audio.stop();
        }
        console.warn(onRejectedReason);
        console.log("Browser does not support autoplaying video without interaction - to resolve this we are going to show the play button overlay.");
    });
}
function showPlayOverlay() {
    let img = document.createElement("img");
    img.id = "playButton";
    img.src = "/images/Play.png";
    img.alt = "Start Streaming";
    setOverlay("clickableState", img, event => {
        playStream();
    });
    shouldShowPlayOverlay = false;
}
function updateAfkOverlayText() {
    afk.overlay.innerHTML = "<center>No activity detected<br>Disconnecting in " + afk.countdown + " seconds<br>Click to continue<br></center>";
}
function showAfkOverlay() {
    stopAfkWarningTimer();
    afk.overlay = document.createElement("div");
    afk.overlay.id = "afkOverlay";
    setOverlay("clickableState", afk.overlay, event => {
        hideOverlay();
        clearInterval(afk.countdownTimer);
        startAfkWarningTimer();
    });
    afk.countdown = afk.closeTimeout;
    updateAfkOverlayText();
    if (inputOptions.controlScheme == ControlSchemeType.HoveringMouse) {
        document.exitPointerLock();
    }
    afk.countdownTimer = setInterval(function () {
        afk.countdown--;
        if (afk.countdown == 0) {
            hideOverlay();
            ws.close();
        } else {
            updateAfkOverlayText();
        }
    }, 1e3);
}
function hideOverlay() {
    setOverlay("hiddenState");
}
function startAfkWarningTimer() {
    afk.active = afk.enabled;
    resetAfkWarningTimer();
}
function stopAfkWarningTimer() {
    afk.active = false;
}
function resetAfkWarningTimer() {
    if (afk.active) {
        clearTimeout(afk.warnTimer);
        afk.warnTimer = setTimeout(function () {
            showAfkOverlay();
        }, afk.warnTimeout * 1e3);
    }
}
function createWebRtcOffer() {
    if (webRtcPlayerObj) {
        console.log("Creating offer");
        showTextOverlay("Starting connection to server, please wait");
        webRtcPlayerObj.createOffer();
    } else {
        console.log("WebRTC player not setup, cannot create offer");
        showTextOverlay("Unable to setup video");
    }
}
function sendInputData(data) {
    if (webRtcPlayerObj) {
        resetAfkWarningTimer();
        webRtcPlayerObj.send(data);
    }
}
function addResponseEventListener(name, listener) {
    responseEventListeners.set(name, listener);
}
function removeResponseEventListener(name) {
    responseEventListeners.remove(name);
}
const ToClientMessageType = { QualityControlOwnership: 0, Response: 1, Command: 2, FreezeFrame: 3, UnfreezeFrame: 4, VideoEncoderAvgQP: 5, LatencyTest: 6, InitialSettings: 7, FileExtension: 8, FileMimeType: 9, FileContents: 10 };
let VideoEncoderQP = "N/A";
function setupWebRtcPlayer(htmlElement, config) {
    webRtcPlayerObj = new webRtcPlayer(config);
    webRtcPlayerObj.video.muted = true;
    autoPlayAudio = typeof config.autoPlayAudio !== "undefined" ? config.autoPlayAudio : true;
    htmlElement.appendChild(webRtcPlayerObj.video);
    htmlElement.appendChild(webRtcPlayerObj.audio);
    htmlElement.appendChild(freezeFrameOverlay);
    webRtcPlayerObj.onWebRtcOffer = function (offer) {
        if (ws && ws.readyState === WS_OPEN_STATE) {
            let offerStr = JSON.stringify(offer);
            ws.send(offerStr);
        }
    };
    webRtcPlayerObj.onWebRtcCandidate = function (candidate) {
        if (ws && ws.readyState === WS_OPEN_STATE) {
            ws.send(JSON.stringify({ type: "iceCandidate", candidate: candidate }));
        }
    };
    webRtcPlayerObj.onWebRtcAnswer = function (answer) {
        if (ws && ws.readyState === WS_OPEN_STATE) {
            let answerStr = JSON.stringify(answer);
            ws.send(answerStr);
        }
    };
    webRtcPlayerObj.onVideoInitialised = function () {
        if (ws && ws.readyState === WS_OPEN_STATE) {
            if (shouldShowPlayOverlay) {
                resizePlayerStyle();
            } else {
                resizePlayerStyle();
                playStream();
            }
        }
    };
    webRtcPlayerObj.onDataChannelConnected = function () {
        if (ws && ws.readyState === WS_OPEN_STATE) {
            showTextOverlay("WebRTC data channel connected... waiting for video");
            requestQualityControl();
        }
    };
    function showFreezeFrame() {
        let base64 = btoa(freezeFrame.jpeg.reduce((data, byte) => data + String.fromCharCode(byte), ""));
        let freezeFrameImage = document.getElementById("freezeFrameOverlay").childNodes[0];
        freezeFrameImage.src = "data:image/jpeg;base64," + base64;
        freezeFrameImage.onload = function () {
            freezeFrame.height = freezeFrameImage.naturalHeight;
            freezeFrame.width = freezeFrameImage.naturalWidth;
            resizeFreezeFrameOverlay();
            if (shouldShowPlayOverlay) {
                resizePlayerStyle();
            } else {
                showFreezeFrameOverlay();
            }
            webRtcPlayerObj.setVideoEnabled(false);
        };
    }
    function processFileExtension(view) {
        if (!file.receiving) {
            file.mimetype = "";
            file.extension = "";
            file.receiving = true;
            file.valid = false;
            file.size = 0;
            file.data = [];
            file.timestampStart = new Date().getTime();
        }
        let extensionAsString = new TextDecoder("utf-16").decode(view.slice(1));
        console.log(extensionAsString);
        file.extension = extensionAsString;
    }
    function processFileMimeType(view) {
        if (!file.receiving) {
            file.mimetype = "";
            file.extension = "";
            file.receiving = true;
            file.valid = false;
            file.size = 0;
            file.data = [];
            file.timestampStart = new Date().getTime();
        }
        let mimeAsString = new TextDecoder("utf-16").decode(view.slice(1));
        console.log(mimeAsString);
        file.mimetype = mimeAsString;
    }
    function processFileContents(view) {
        if (!file.receiving) return;
        file.size = Math.ceil(new DataView(view.slice(1, 5).buffer).getInt32(0, true) / 16379);
        let fileBytes = view.slice(1 + 4);
        file.data.push(fileBytes);
        if (file.data.length === file.size) {
            file.receiving = false;
            file.valid = true;
            const transferDuration = new Date().getTime() - file.timestampStart;
            const transferBitrate = Math.round((file.size * 16 * 1024) / transferDuration);
            console.log(`Average transfer bitrate: ${transferBitrate}kb/s over ${transferDuration / 1e3} seconds`);
            var received = new Blob(file.data, { type: file.mimetype });
            var a = document.createElement("a");
            a.setAttribute("href", URL.createObjectURL(received));
            a.setAttribute("download", `transfer.${file.extension}`);
            var aj = $(a);
            aj.appendTo("body");
            aj.remove();
        } else if (file.data.length > file.size) {
            file.receiving = false;
        }
    }
    function processFreezeFrameMessage(view) {
        if (!freezeFrame.receiving) {
            freezeFrame.receiving = true;
            freezeFrame.valid = false;
            freezeFrame.size = 0;
            freezeFrame.jpeg = undefined;
        }
        freezeFrame.size = new DataView(view.slice(1, 5).buffer).getInt32(0, true);
        let jpegBytes = view.slice(1 + 4);
        if (freezeFrame.jpeg) {
            let jpeg = new Uint8Array(freezeFrame.jpeg.length + jpegBytes.length);
            jpeg.set(freezeFrame.jpeg, 0);
            jpeg.set(jpegBytes, freezeFrame.jpeg.length);
            freezeFrame.jpeg = jpeg;
        } else {
            freezeFrame.jpeg = jpegBytes;
            freezeFrame.receiving = true;
        }
        if (freezeFrame.jpeg.length === freezeFrame.size) {
            freezeFrame.receiving = false;
            freezeFrame.valid = true;
            showFreezeFrame();
        } else if (freezeFrame.jpeg.length > freezeFrame.size) {
            console.warn(`received bigger freeze frame than advertised: ${freezeFrame.jpeg.length}/${freezeFrame.size}`);
            freezeFrame.jpeg = undefined;
            freezeFrame.receiving = false;
        }
    }
    webRtcPlayerObj.onNewVideoTrack = function (streams) {
        if (webRtcPlayerObj.video && webRtcPlayerObj.video.srcObject && webRtcPlayerObj.onVideoInitialised) {
            webRtcPlayerObj.onVideoInitialised();
        }
    };
    webRtcPlayerObj.onDataChannelMessage = function (data) {
        let view = new Uint8Array(data);
        if (view[0] === ToClientMessageType.QualityControlOwnership) {
            let ownership = view[1] === 0 ? false : true;
            qualityController = ownership;
            if (qualityControlOwnershipCheckBox !== null) {
                qualityControlOwnershipCheckBox.disabled = ownership;
                qualityControlOwnershipCheckBox.checked = ownership;
            }
        } else if (view[0] === ToClientMessageType.Response) {
            let response = new TextDecoder("utf-16").decode(data.slice(1));
            for (let listener of responseEventListeners.values()) {
                listener(response);
            }
        } else if (view[0] === ToClientMessageType.Command) {
            let commandAsString = new TextDecoder("utf-16").decode(data.slice(1));
            console.log(commandAsString);
            let command = JSON.parse(commandAsString);
            if (command.command === "onScreenKeyboard") {
                showOnScreenKeyboard(command);
            }
        } else if (view[0] === ToClientMessageType.FreezeFrame) {
            processFreezeFrameMessage(view);
        } else if (view[0] === ToClientMessageType.UnfreezeFrame) {
            invalidateFreezeFrameOverlay();
        } else if (view[0] === ToClientMessageType.VideoEncoderAvgQP) {
            VideoEncoderQP = new TextDecoder("utf-16").decode(data.slice(1));
        } else if (view[0] == ToClientMessageType.LatencyTest) {
            let latencyTimingsAsString = new TextDecoder("utf-16").decode(data.slice(1));
            console.log("Got latency timings from UE.");
            console.log(latencyTimingsAsString);
            let latencyTimingsFromUE = JSON.parse(latencyTimingsAsString);
            if (webRtcPlayerObj) {
                webRtcPlayerObj.latencyTestTimings.SetUETimings(latencyTimingsFromUE);
            }
        } else if (view[0] == ToClientMessageType.InitialSettings) {
            let settingsString = new TextDecoder("utf-16").decode(data.slice(1));
            let settingsJSON = JSON.parse(settingsString);
            if (settingsJSON.PixelStreaming) {
                let allowConsoleCommands = settingsJSON.PixelStreaming.AllowPixelStreamingCommands;
                if (allowConsoleCommands === false) {
                    if (document.getElementById("encoder-min-qp-text")) {
                        document.getElementById("encoder-min-qp-text").disabled = true;
                    }
                    if (document.getElementById("encoder-max-qp-text")) {
                        document.getElementById("encoder-max-qp-text").disabled = true;
                    }
                    if (document.getElementById("webrtc-fps-text")) {
                        document.getElementById("webrtc-fps-text").disabled = true;
                    }
                    if (document.getElementById("webrtc-min-bitrate-text")) {
                        document.getElementById("webrtc-min-bitrate-text").disabled = true;
                    }
                    if (document.getElementById("webrtc-max-bitrate-text")) {
                        document.getElementById("webrtc-max-bitrate-text").disabled = true;
                    }
                    if (document.getElementById("webrtc-max-bitrate-text")) {
                        document.getElementById("webrtc-max-bitrate-text").disabled = true;
                    }
                    if (document.getElementById("webrtc-max-bitrate-text")) {
                        document.getElementById("webrtc-max-bitrate-text").disabled = true;
                    }
                    if (document.getElementById("webrtc-max-bitrate-text")) {
                        document.getElementById("webrtc-max-bitrate-text").disabled = true;
                    }
                    if (!document.getElementById("warning-elem-webrtc")) {
                        let warningElem1 = document.createElement("p");
                        warningElem1.innerText = "(Disabled by -AllowPixelStreamingCommands=false)";
                        warningElem1.classList = "subtitle-text";
                        warningElem1.id = "warning-elem-webrtc";
                        if (document.getElementById("webRTCSettingsHeader")) {
                            document.getElementById("webRTCSettingsHeader").appendChild(warningElem1);
                        }
                    }
                    if (!document.getElementById("warning-elem-encoder")) {
                        let warningElem2 = document.createElement("p");
                        warningElem2.innerText = "(Disabled by -AllowPixelStreamingCommands=false)";
                        warningElem2.classList = "subtitle-text";
                        warningElem2.id = "warning-elem-encoder";
                        if (document.getElementById("encoderSettingsHeader")) {
                            document.getElementById("encoderSettingsHeader").appendChild(warningElem2);
                        }
                    }
                    console.warn("-AllowPixelStreamingCommands=false, sending console commands from browser to UE is disabled, including toggling FPS and changing encoder settings from the browser.");
                }
                let disableLatencyTest = settingsJSON.PixelStreaming.DisableLatencyTest;
                if (disableLatencyTest) {
                    document.getElementById("test-latency-button").disabled = true;
                    document.getElementById("test-latency-button").title = "Disabled by -PixelStreamingDisableLatencyTester=true";
                    console.warn("-PixelStreamingDisableLatencyTester=true, requesting latency report from the the browser to UE is disabled.");
                }
            }
            if (settingsJSON.Encoder) {
                if (document.getElementById("encoder-min-qp-text")) {
                    document.getElementById("encoder-min-qp-text").value = settingsJSON.Encoder.MinQP;
                }
                if (document.getElementById("encoder-max-qp-text")) {
                    document.getElementById("encoder-max-qp-text").value = settingsJSON.Encoder.MaxQP;
                }
            }
            if (settingsJSON.WebRTC) {
                if (document.getElementById("webrtc-fps-text")) {
                    document.getElementById("webrtc-fps-text").value = settingsJSON.WebRTC.FPS;
                }
                if (document.getElementById("webrtc-min-bitrate-text")) {
                    document.getElementById("webrtc-min-bitrate-text").value = settingsJSON.WebRTC.MinBitrate / 1e3;
                }
                if (document.getElementById("webrtc-max-bitrate-text")) {
                    document.getElementById("webrtc-max-bitrate-text").value = settingsJSON.WebRTC.MaxBitrate / 1e3;
                }
            }
        } else if (view[0] == ToClientMessageType.FileExtension) {
            processFileExtension(view);
        } else if (view[0] == ToClientMessageType.FileMimeType) {
            processFileMimeType(view);
        } else if (view[0] == ToClientMessageType.FileContents) {
            processFileContents(view);
        } else {
            console.warn(`unrecognized data received, packet ID ${view[0]}`);
        }
    };
    registerInputs(webRtcPlayerObj.video);
    if ("ontouchstart" in document.documentElement) {
    }
    return webRtcPlayerObj.video;
}
function setupStats() {
    webRtcPlayerObj.aggregateStats(1 * 1e3);
    let printInterval = 5 * 60 * 1e3;
    let nextPrintDuration = printInterval;
    webRtcPlayerObj.onAggregatedStats = aggregatedStats => {
        let numberFormat = new Intl.NumberFormat(window.navigator.language, { maximumFractionDigits: 0 });
        let timeFormat = new Intl.NumberFormat(window.navigator.language, { maximumFractionDigits: 0, minimumIntegerDigits: 2 });
        let runTime = (aggregatedStats.timestamp - aggregatedStats.timestampStart) / 1e3;
        let timeValues = [];
        let timeDurations = [60, 60];
        for (let timeIndex = 0; timeIndex < timeDurations.length; timeIndex++) {
            timeValues.push(runTime % timeDurations[timeIndex]);
            runTime = runTime / timeDurations[timeIndex];
        }
        timeValues.push(runTime);
        let runTimeSeconds = timeValues[0];
        let runTimeMinutes = Math.floor(timeValues[1]);
        let runTimeHours = Math.floor([timeValues[2]]);
        let receivedBytesMeasurement = "B";
        let receivedBytes = aggregatedStats.hasOwnProperty("bytesReceived") ? aggregatedStats.bytesReceived : 0;
        let dataMeasurements = ["kB", "MB", "GB"];
        for (let index = 0; index < dataMeasurements.length; index++) {
            if (receivedBytes < 100 * 1e3) break;
            receivedBytes = receivedBytes / 1e3;
            receivedBytesMeasurement = dataMeasurements[index];
        }
        let qualityStatus = document.getElementById("qualityStatus");
        let blinkQualityStatus = function (speed) {
            let iter = speed;
            let opacity = 1;
            let tickId = setInterval(function () {
                opacity -= 0.1;
                qualityStatus.style = `opacity: ${Math.abs((opacity - 0.5) * 2)}`;
                if (opacity <= 0.1) {
                    if (--iter == 0) {
                        clearInterval(tickId);
                    } else {
                        opacity = 1;
                    }
                }
            }, 100 / speed);
        };
        const orangeQP = 26;
        const redQP = 35;
        let statsText = "";
        let color = "lime";
        if (VideoEncoderQP > redQP) {
            color = "red";
            blinkQualityStatus(2);
            statsText += `<div style="color: ${color}">Very blocky encoding quality</div>`;
        } else if (VideoEncoderQP > orangeQP) {
            color = "orange";
            blinkQualityStatus(1);
            statsText += `<div style="color: ${color}">Blocky encoding quality</div>`;
        }
        qualityStatus.className = `${color}Status`;
        statsText += `<div>Duration: ${timeFormat.format(runTimeHours)}:${timeFormat.format(runTimeMinutes)}:${timeFormat.format(runTimeSeconds)}</div>`;
        statsText += `<div>Video Resolution: ${
            aggregatedStats.hasOwnProperty("frameWidth") && aggregatedStats.frameWidth && aggregatedStats.hasOwnProperty("frameHeight") && aggregatedStats.frameHeight ? aggregatedStats.frameWidth + "x" + aggregatedStats.frameHeight : "Chrome only"
        }</div>`;
        statsText += `<div>Received (${receivedBytesMeasurement}): ${numberFormat.format(receivedBytes)}</div>`;
        statsText += `<div>Frames Decoded: ${aggregatedStats.hasOwnProperty("framesDecoded") ? numberFormat.format(aggregatedStats.framesDecoded) : "Chrome only"}</div>`;
        statsText += `<div>Packets Lost: ${aggregatedStats.hasOwnProperty("packetsLost") ? numberFormat.format(aggregatedStats.packetsLost) : "Chrome only"}</div>`;
        statsText += `<div>Framerate: ${aggregatedStats.hasOwnProperty("framerate") ? numberFormat.format(aggregatedStats.framerate) : "Chrome only"}</div>`;
        statsText += `<div>Frames dropped: ${aggregatedStats.hasOwnProperty("framesDropped") ? numberFormat.format(aggregatedStats.framesDropped) : "Chrome only"}</div>`;
        statsText += `<div>Net RTT (ms): ${aggregatedStats.hasOwnProperty("currentRoundTripTime") ? numberFormat.format(aggregatedStats.currentRoundTripTime * 1e3) : "Can't calculate"}</div>`;
        statsText += `<div>Browser receive to composite (ms): ${aggregatedStats.hasOwnProperty("receiveToCompositeMs") ? numberFormat.format(aggregatedStats.receiveToCompositeMs) : "Chrome only"}</div>`;
        statsText += `<div style="color: ${color}">Bitrate (kbps): ${aggregatedStats.hasOwnProperty("bitrate") ? numberFormat.format(aggregatedStats.bitrate) : "Chrome only"}</div>`;
        statsText += `<div style="color: ${color}">Video Quantization Parameter: ${VideoEncoderQP}</div>`;
        let statsDiv = document.getElementById("stats");
        statsDiv.innerHTML = statsText;
        if (print_stats) {
            if (aggregatedStats.timestampStart) {
                if (aggregatedStats.timestamp - aggregatedStats.timestampStart > nextPrintDuration) {
                    if (ws && ws.readyState === WS_OPEN_STATE) {
                        console.log(`-> SS: stats\n${JSON.stringify(aggregatedStats)}`);
                        ws.send(JSON.stringify({ type: "stats", data: aggregatedStats }));
                    }
                    nextPrintDuration += printInterval;
                }
            }
        }
    };
    webRtcPlayerObj.latencyTestTimings.OnAllLatencyTimingsReady = function (timings) {
        if (!timings.BrowserReceiptTimeMs) {
            return;
        }
        let latencyExcludingDecode = timings.BrowserReceiptTimeMs - timings.TestStartTimeMs;
        let encodeLatency = timings.UEEncodeMs;
        let uePixelStreamLatency = timings.UECaptureToSendMs;
        let ueTestDuration = timings.UETransmissionTimeMs - timings.UEReceiptTimeMs;
        let networkLatency = latencyExcludingDecode - ueTestDuration;
        let endToEndLatency = null;
        let browserSideLatency = null;
        if (timings.FrameDisplayDeltaTimeMs && timings.BrowserReceiptTimeMs) {
            endToEndLatency = timings.FrameDisplayDeltaTimeMs + networkLatency + (typeof uePixelStreamLatency === "string" ? 0 : uePixelStreamLatency);
            browserSideLatency = timings.FrameDisplayDeltaTimeMs + (latencyExcludingDecode - networkLatency - ueTestDuration);
        }
        let latencyStatsInnerHTML = "";
        latencyStatsInnerHTML += `<div>Net latency RTT (ms): ${networkLatency.toFixed(2)}</div>`;
        latencyStatsInnerHTML += `<div>UE Encode (ms): ${typeof encodeLatency === "string" ? encodeLatency : encodeLatency.toFixed(2)}</div>`;
        latencyStatsInnerHTML += `<div>UE Send to capture (ms): ${typeof uePixelStreamLatency === "string" ? uePixelStreamLatency : uePixelStreamLatency.toFixed(2)}</div>`;
        latencyStatsInnerHTML += `<div>UE probe duration (ms): ${ueTestDuration.toFixed(2)}</div>`;
        latencyStatsInnerHTML += timings.FrameDisplayDeltaTimeMs && timings.BrowserReceiptTimeMs ? `<div>Browser composite latency (ms): ${timings.FrameDisplayDeltaTimeMs.toFixed(2)}</div>` : "";
        latencyStatsInnerHTML += browserSideLatency ? `<div>Total browser latency (ms): ${browserSideLatency.toFixed(2)}</div>` : "";
        latencyStatsInnerHTML += endToEndLatency ? `<div>Total latency (ms): ${endToEndLatency.toFixed(2)}</div>` : "";
        document.getElementById("LatencyStats").innerHTML = latencyStatsInnerHTML;
    };
}
function onWebRtcOffer(webRTCData) {
    webRtcPlayerObj.receiveOffer(webRTCData);
}
function onWebRtcAnswer(webRTCData) {
    webRtcPlayerObj.receiveAnswer(webRTCData);
}
function onWebRtcIce(iceCandidate) {
    if (webRtcPlayerObj) {
        webRtcPlayerObj.handleCandidateFromServer(iceCandidate);
    }
}
let styleWidth;
let styleHeight;
let styleTop;
let styleLeft;
let styleCursor = "default";
let styleAdditional;
const ControlSchemeType = { LockedMouse: 0, HoveringMouse: 1 };
let inputOptions = { controlScheme: ControlSchemeType.HoveringMouse, suppressBrowserKeys: false, fakeMouseWithTouches: true };
function resizePlayerStyleToFillWindow(playerElement) {
    let videoElement = playerElement.getElementsByTagName("VIDEO");
    let windowAspectRatio = window.innerHeight / window.innerWidth;
    let playerAspectRatio = playerElement.clientHeight / playerElement.clientWidth;
    let videoAspectRatio = videoElement.videoHeight / videoElement.videoWidth;
    if (isNaN(videoAspectRatio)) {
        styleWidth = window.innerWidth;
        styleHeight = window.innerHeight;
        styleTop = 0;
        styleLeft = 0;
        playerElement.style = "top: " + styleTop + "px; left: 10%; width: " + styleWidth + "px; height: " + styleHeight + "px; cursor: " + styleCursor + "; " + styleAdditional;
    } else if (windowAspectRatio < playerAspectRatio) {
        styleWidth = Math.floor(window.innerHeight / videoAspectRatio);
        styleHeight = window.innerHeight;
        styleTop = 0;
        styleLeft = Math.floor((window.innerWidth - styleWidth) * 0.5);
        playerElement.style = "top: " + styleTop + "px; left: " + styleLeft + "px; width: " + styleWidth + "px; height: " + styleHeight + "px; cursor: " + styleCursor + "; " + styleAdditional;
    } else {
        styleWidth = window.innerWidth;
        styleHeight = Math.floor(window.innerWidth * videoAspectRatio);
        styleTop = Math.floor((window.innerHeight - styleHeight) * 0.5);
        styleLeft = 0;
        playerElement.style = "top: " + styleTop + "px; left: " + styleLeft + "px; width: " + styleWidth + "px; height: " + styleHeight + "px; cursor: " + styleCursor + "; " + styleAdditional;
    }
}
function resizePlayerStyleToActualSize(playerElement) {
    let videoElement = playerElement.getElementsByTagName("VIDEO");
    if (videoElement.length > 0) {
        styleWidth = videoElement[0].videoWidth;
        styleHeight = videoElement[0].videoHeight;
        let Top = Math.floor((window.innerHeight - styleHeight) * 0.5);
        let Left = Math.floor((window.innerWidth - styleWidth) * 0.5);
        styleTop = Top > 0 ? Top : 0;
        styleLeft = Left > 0 ? Left : 0;
        playerElement.style = "top: " + styleTop + "px; left: " + styleLeft + "px; width: " + styleWidth + "px; height: " + styleHeight + "px; cursor: " + styleCursor + "; " + styleAdditional;
    }
}
function resizePlayerStyleToArbitrarySize(playerElement) {
    let videoElement = playerElement.getElementsByTagName("VIDEO");
    playerElement.style = "top: 0px; left: 0px; width: " + styleWidth + "px; height: " + styleHeight + "px; cursor: " + styleCursor + "; " + styleAdditional;
}
function setupFreezeFrameOverlay() {
    let checkBox = document.getElementById("freezeFrameOverlay");
    if (!checkBox) {
        freezeFrameOverlay = document.createElement("div");
        freezeFrameOverlay.id = "freezeFrameOverlay";
        freezeFrameOverlay.style.display = "none";
        freezeFrameOverlay.style.pointerEvents = "none";
        freezeFrameOverlay.style.position = "absolute";
        freezeFrameOverlay.style.zIndex = "20";
        let freezeFrameImage = document.createElement("img");
        freezeFrameImage.style.position = "absolute";
        freezeFrameOverlay.appendChild(freezeFrameImage);
    }
}
function showFreezeFrameOverlay() {
    if (freezeFrame.valid) {
        freezeFrameOverlay.classList.add("freezeframeBackground");
        freezeFrameOverlay.style.display = "block";
    }
}
function invalidateFreezeFrameOverlay() {
    freezeFrameOverlay.style.display = "none";
    freezeFrame.valid = false;
    freezeFrameOverlay.classList.remove("freezeframeBackground");
    if (webRtcPlayerObj) {
        webRtcPlayerObj.setVideoEnabled(true);
    }
}
function resizeFreezeFrameOverlay() {
    if (freezeFrame.width !== 0 && freezeFrame.height !== 0) {
        let displayWidth = 0;
        let displayHeight = 0;
        let displayTop = 0;
        let displayLeft = 0;
        let checkBox = document.getElementById("enlarge-display-to-fill-window-tgl");
        let playerElement = webrtc.dom;
        if (checkBox !== null && checkBox.checked) {
            let windowAspectRatio = window.innerWidth / window.innerHeight;
            let videoAspectRatio = freezeFrame.width / freezeFrame.height;
            if (windowAspectRatio < videoAspectRatio) {
                displayWidth = window.innerWidth;
                displayHeight = Math.floor(window.innerWidth / videoAspectRatio);
                displayTop = Math.floor((window.innerHeight - displayHeight) * 0.5);
                displayLeft = 0;
            } else {
                displayWidth = Math.floor(window.innerHeight * videoAspectRatio);
                displayHeight = window.innerHeight;
                displayTop = 0;
                displayLeft = Math.floor((window.innerWidth - displayWidth) * 0.5);
            }
        } else {
            let playerAspectRatio = playerElement.offsetWidth / playerElement.offsetHeight;
            let videoAspectRatio = freezeFrame.width / freezeFrame.height;
            if (playerAspectRatio < videoAspectRatio) {
                displayWidth = playerElement.offsetWidth;
                displayHeight = Math.floor(playerElement.offsetWidth / videoAspectRatio);
                displayTop = Math.floor((playerElement.offsetHeight - displayHeight) * 0.5);
                displayLeft = 0;
            } else {
                displayWidth = Math.floor(playerElement.offsetHeight * videoAspectRatio);
                displayHeight = playerElement.offsetHeight;
                displayTop = 0;
                displayLeft = Math.floor((playerElement.offsetWidth - displayWidth) * 0.5);
            }
        }
        let freezeFrameImage = document.getElementById("freezeFrameOverlay").childNodes[0];
        freezeFrameOverlay.style.width = playerElement.offsetWidth + "px";
        freezeFrameOverlay.style.height = playerElement.offsetHeight + "px";
        freezeFrameOverlay.style.left = 0 + "px";
        freezeFrameOverlay.style.top = 0 + "px";
        freezeFrameImage.style.width = displayWidth + "px";
        freezeFrameImage.style.height = displayHeight + "px";
        freezeFrameImage.style.left = displayLeft + "px";
        freezeFrameImage.style.top = displayTop + "px";
    }
}
function resizePlayerStyle(event) {
    let playerElement = webrtc.dom;
    if (!playerElement) return;
    updateVideoStreamSize();
    if (playerElement.classList.contains("fixed-size")) {
        setupMouseAndFreezeFrame(playerElement);
        return;
    }
    let checkBox = document.getElementById("enlarge-display-to-fill-window-tgl");
    let windowSmallerThanPlayer = window.innerWidth < playerElement.videoWidth || window.innerHeight < playerElement.videoHeight;
    if (checkBox !== null) {
        if (checkBox.checked || windowSmallerThanPlayer) {
            resizePlayerStyleToFillWindow(playerElement);
        } else {
            resizePlayerStyleToActualSize(playerElement);
        }
    } else {
        resizePlayerStyleToArbitrarySize(playerElement);
    }
    setupMouseAndFreezeFrame(playerElement);
}
function setupMouseAndFreezeFrame(playerElement) {
    playerElementClientRect = playerElement.getBoundingClientRect();
    setupNormalizeAndQuantize();
    resizeFreezeFrameOverlay();
}
function updateVideoStreamSize() {
    if (!matchViewportResolution) {
        return;
    }
    let now = new Date().getTime();
    if (now - lastTimeResized > 1e3) {
        let playerElement = webrtc.dom;
        if (!playerElement) return;
        let descriptor = { "Resolution.Width": playerElement.clientWidth, "Resolution.Height": playerElement.clientHeight };
        console.log("descriptor", descriptor);
        emitCommand(descriptor);
        if (window.innerWidth >= 3800) {
            console.log("屏幕宽度大于等于3800ue交互传参", 0);
            emitCommand({ path1: 0 });
        }
        lastTimeResized = new Date().getTime();
    } else {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(updateVideoStreamSize, 1e3);
    }
}
let _orientationChangeTimeout;
function onOrientationChange(event) {
    clearTimeout(_orientationChangeTimeout);
    _orientationChangeTimeout = setTimeout(function () {
        resizePlayerStyle();
    }, 500);
}
const MessageType = {
    IFrameRequest: 0,
    RequestQualityControl: 1,
    FpsRequest: 2,
    AverageBitrateRequest: 3,
    StartStreaming: 4,
    StopStreaming: 5,
    LatencyTest: 6,
    RequestInitialSettings: 7,
    UIInteraction: 50,
    Command: 51,
    KeyDown: 60,
    KeyUp: 61,
    KeyPress: 62,
    MouseEnter: 70,
    MouseLeave: 71,
    MouseDown: 72,
    MouseUp: 73,
    MouseMove: 74,
    MouseWheel: 75,
    TouchStart: 80,
    TouchEnd: 81,
    TouchMove: 82,
    GamepadButtonPressed: 90,
    GamepadButtonReleased: 91,
    GamepadAnalog: 92,
};
function emitDescriptor(messageType, descriptor) {
    let descriptorAsString = JSON.stringify(descriptor);
    let data = new DataView(new ArrayBuffer(1 + 2 + 2 * descriptorAsString.length));
    let byteIdx = 0;
    data.setUint8(byteIdx, messageType);
    byteIdx++;
    data.setUint16(byteIdx, descriptorAsString.length, true);
    byteIdx += 2;
    for (let i = 0; i < descriptorAsString.length; i++) {
        data.setUint16(byteIdx, descriptorAsString.charCodeAt(i), true);
        byteIdx += 2;
    }
    sendInputData(data.buffer);
}
function emitUIInteraction(descriptor) {
    emitDescriptor(MessageType.UIInteraction, descriptor);
}
function emitCommand(descriptor) {
    emitDescriptor(MessageType.Command, descriptor);
}
function requestInitialSettings() {
    sendInputData(new Uint8Array([MessageType.RequestInitialSettings]).buffer);
}
function requestQualityControl() {
    if (!qualityController) {
        sendInputData(new Uint8Array([MessageType.RequestQualityControl]).buffer);
    }
}
let playerElementClientRect = undefined;
let normalizeAndQuantizeUnsigned = undefined;
let normalizeAndQuantizeSigned = undefined;
let unquantizeAndDenormalizeUnsigned = undefined;
function setupNormalizeAndQuantize() {
    let playerElement = webrtc.dom;
    let videoElement = playerElement.getElementsByTagName("video");
    if (playerElement && videoElement.length > 0) {
        let playerAspectRatio = playerElement.clientHeight / playerElement.clientWidth;
        let videoAspectRatio = videoElement[0].videoHeight / videoElement[0].videoWidth;
        if (playerAspectRatio > videoAspectRatio) {
            if (print_inputs) {
                console.log("Setup Normalize and Quantize for playerAspectRatio > videoAspectRatio");
            }
            let ratio = playerAspectRatio / videoAspectRatio;
            normalizeAndQuantizeUnsigned = (x, y) => {
                let normalizedX = x / playerElement.clientWidth;
                let normalizedY = ratio * (y / playerElement.clientHeight - 0.5) + 0.5;
                if (normalizedX < 0 || normalizedX > 1 || normalizedY < 0 || normalizedY > 1) {
                    return { inRange: false, x: 65535, y: 65535 };
                } else {
                    return { inRange: true, x: normalizedX * 65536, y: normalizedY * 65536 };
                }
            };
            unquantizeAndDenormalizeUnsigned = (x, y) => {
                let normalizedX = x / 65536;
                let normalizedY = (y / 65536 - 0.5) / ratio + 0.5;
                return { x: normalizedX * playerElement.clientWidth, y: normalizedY * playerElement.clientHeight };
            };
            normalizeAndQuantizeSigned = (x, y) => {
                let normalizedX = x / (0.5 * playerElement.clientWidth);
                let normalizedY = (ratio * y) / (0.5 * playerElement.clientHeight);
                return { x: normalizedX * 32767, y: normalizedY * 32767 };
            };
        } else {
            if (print_inputs) {
                console.log("Setup Normalize and Quantize for playerAspectRatio <= videoAspectRatio");
            }
            let ratio = videoAspectRatio / playerAspectRatio;
            normalizeAndQuantizeUnsigned = (x, y) => {
                let normalizedX = ratio * (x / playerElement.clientWidth - 0.5) + 0.5;
                let normalizedY = y / playerElement.clientHeight;
                if (normalizedX < 0 || normalizedX > 1 || normalizedY < 0 || normalizedY > 1) {
                    return { inRange: false, x: 65535, y: 65535 };
                } else {
                    return { inRange: true, x: normalizedX * 65536, y: normalizedY * 65536 };
                }
            };
            unquantizeAndDenormalizeUnsigned = (x, y) => {
                let normalizedX = (x / 65536 - 0.5) / ratio + 0.5;
                let normalizedY = y / 65536;
                return { x: normalizedX * playerElement.clientWidth, y: normalizedY * playerElement.clientHeight };
            };
            normalizeAndQuantizeSigned = (x, y) => {
                let normalizedX = (ratio * x) / (0.5 * playerElement.clientWidth);
                let normalizedY = y / (0.5 * playerElement.clientHeight);
                return { x: normalizedX * 32767, y: normalizedY * 32767 };
            };
        }
    }
}
function emitMouseMove(x, y, deltaX, deltaY) {
    if (print_inputs) {
        console.log(`x: ${x}, y:${y}, dX: ${deltaX}, dY: ${deltaY}`);
    }
    let coord = normalizeAndQuantizeUnsigned(x, y);
    let delta = normalizeAndQuantizeSigned(deltaX, deltaY);
    let Data = new DataView(new ArrayBuffer(9));
    Data.setUint8(0, MessageType.MouseMove);
    Data.setUint16(1, coord.x, true);
    Data.setUint16(3, coord.y, true);
    Data.setInt16(5, delta.x, true);
    Data.setInt16(7, delta.y, true);
    sendInputData(Data.buffer);
}
function emitMouseDown(button, x, y) {
    if (print_inputs) {
        console.log(`mouse button ${button} down at (${x}, ${y})`);
    }
    let coord = normalizeAndQuantizeUnsigned(x, y);
    let Data = new DataView(new ArrayBuffer(6));
    Data.setUint8(0, MessageType.MouseDown);
    Data.setUint8(1, button);
    Data.setUint16(2, coord.x, true);
    Data.setUint16(4, coord.y, true);
    sendInputData(Data.buffer);
}
function emitMouseUp(button, x, y) {
    if (print_inputs) {
        console.log(`mouse button ${button} up at (${x}, ${y})`);
    }
    let coord = normalizeAndQuantizeUnsigned(x, y);
    let Data = new DataView(new ArrayBuffer(6));
    Data.setUint8(0, MessageType.MouseUp);
    Data.setUint8(1, button);
    Data.setUint16(2, coord.x, true);
    Data.setUint16(4, coord.y, true);
    sendInputData(Data.buffer);
}
function emitMouseWheel(delta, x, y) {
    if (print_inputs) {
        console.log(`mouse wheel with delta ${delta} at (${x}, ${y})`);
    }
    let coord = normalizeAndQuantizeUnsigned(x, y);
    let Data = new DataView(new ArrayBuffer(7));
    Data.setUint8(0, MessageType.MouseWheel);
    Data.setInt16(1, delta, true);
    Data.setUint16(3, coord.x, true);
    Data.setUint16(5, coord.y, true);
    sendInputData(Data.buffer);
}
const MouseButton = { MainButton: 0, AuxiliaryButton: 1, SecondaryButton: 2, FourthButton: 3, FifthButton: 4 };
const MouseButtonsMask = { PrimaryButton: 1, SecondaryButton: 2, AuxiliaryButton: 4, FourthButton: 8, FifthButton: 16 };
function releaseMouseButtons(buttons, x, y) {
    if (buttons & MouseButtonsMask.PrimaryButton) {
        emitMouseUp(MouseButton.MainButton, x, y);
    }
    if (buttons & MouseButtonsMask.SecondaryButton) {
        emitMouseUp(MouseButton.SecondaryButton, x, y);
    }
    if (buttons & MouseButtonsMask.AuxiliaryButton) {
        emitMouseUp(MouseButton.AuxiliaryButton, x, y);
    }
    if (buttons & MouseButtonsMask.FourthButton) {
        emitMouseUp(MouseButton.FourthButton, x, y);
    }
    if (buttons & MouseButtonsMask.FifthButton) {
        emitMouseUp(MouseButton.FifthButton, x, y);
    }
}
function pressMouseButtons(buttons, x, y) {
    if (buttons & MouseButtonsMask.PrimaryButton) {
        emitMouseDown(MouseButton.MainButton, x, y);
    }
    if (buttons & MouseButtonsMask.SecondaryButton) {
        emitMouseDown(MouseButton.SecondaryButton, x, y);
    }
    if (buttons & MouseButtonsMask.AuxiliaryButton) {
        emitMouseDown(MouseButton.AuxiliaryButton, x, y);
    }
    if (buttons & MouseButtonsMask.FourthButton) {
        emitMouseDown(MouseButton.FourthButton, x, y);
    }
    if (buttons & MouseButtonsMask.FifthButton) {
        emitMouseDown(MouseButton.FifthButton, x, y);
    }
}
function registerInputs(playerElement) {
    if (!playerElement) return;
    registerMouseEnterAndLeaveEvents(playerElement);
    registerTouchEvents(playerElement);
}
function createOnScreenKeyboardHelpers(htmlElement) {
    if (document.getElementById("hiddenInput") === null) {
        hiddenInput = document.createElement("input");
        hiddenInput.id = "hiddenInput";
        hiddenInput.maxLength = 0;
        htmlElement.appendChild(hiddenInput);
    }
    if (document.getElementById("editTextButton") === null) {
        editTextButton = document.createElement("button");
        editTextButton.id = "editTextButton";
        editTextButton.innerHTML = "edit text";
        htmlElement.appendChild(editTextButton);
        editTextButton.classList.add("hiddenState");
        editTextButton.addEventListener("click", function () {
            hiddenInput.focus();
        });
    }
}
function showOnScreenKeyboard(command) {
    if (command.showOnScreenKeyboard) {
        editTextButton.classList.remove("hiddenState");
        let pos = unquantizeAndDenormalizeUnsigned(command.x, command.y);
        editTextButton.style.top = pos.y.toString() + "px";
        editTextButton.style.left = (pos.x - 40).toString() + "px";
    } else {
        editTextButton.classList.add("hiddenState");
        hiddenInput.blur();
    }
}
function registerMouseEnterAndLeaveEvents(playerElement) {
    playerElement.onmouseenter = function (e) {
        if (print_inputs) {
            console.log("mouse enter");
        }
        let Data = new DataView(new ArrayBuffer(1));
        Data.setUint8(0, MessageType.MouseEnter);
        sendInputData(Data.buffer);
        playerElement.pressMouseButtons(e);
    };
    playerElement.onmouseleave = function (e) {
        if (print_inputs) {
            console.log("mouse leave");
        }
        let Data = new DataView(new ArrayBuffer(1));
        Data.setUint8(0, MessageType.MouseLeave);
        sendInputData(Data.buffer);
        playerElement.releaseMouseButtons(e);
    };
}
function registerLockedMouseEvents(playerElement) {
    let x = playerElement.width / 2;
    let y = playerElement.height / 2;
    playerElement.requestPointerLock = playerElement.requestPointerLock || playerElement.mozRequestPointerLock;
    document.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock;
    playerElement.onclick = function () {
        playerElement.requestPointerLock();
    };
    document.addEventListener("pointerlockchange", lockStateChange, false);
    document.addEventListener("mozpointerlockchange", lockStateChange, false);
    function lockStateChange() {
        if (document.pointerLockElement === playerElement || document.mozPointerLockElement === playerElement) {
            console.log("Pointer locked");
            document.addEventListener("mousemove", updatePosition, false);
        } else {
            console.log("The pointer lock status is now unlocked");
            document.removeEventListener("mousemove", updatePosition, false);
            [...new Set(activeKeys)].forEach(uniqueKeycode => {
                sendInputData(new Uint8Array([MessageType.KeyUp, uniqueKeycode]).buffer);
            });
            activeKeys = [];
        }
    }
    function updatePosition(e) {
        x += e.movementX;
        y += e.movementY;
        if (x > styleWidth) {
            x -= styleWidth;
        }
        if (y > styleHeight) {
            y -= styleHeight;
        }
        if (x < 0) {
            x = styleWidth + x;
        }
        if (y < 0) {
            y = styleHeight - y;
        }
        emitMouseMove(x, y, e.movementX, e.movementY);
    }
    playerElement.onmousedown = function (e) {
        emitMouseDown(e.button, x, y);
    };
    playerElement.onmouseup = function (e) {
        emitMouseUp(e.button, x, y);
    };
    playerElement.onmousewheel = function (e) {
        emitMouseWheel(e.wheelDelta, x, y);
    };
    playerElement.pressMouseButtons = function (e) {
        pressMouseButtons(e.buttons, x, y);
    };
    playerElement.releaseMouseButtons = function (e) {
        releaseMouseButtons(e.buttons, x, y);
    };
}
function registerHoveringMouseEvents(playerElement) {
    styleCursor = "default";
    playerElement.onmousemove = function (e) {
        emitMouseMove(e.offsetX, e.offsetY, e.movementX, e.movementY);
        e.preventDefault();
    };
    playerElement.onmousedown = function (e) {
        emitMouseDown(e.button, e.offsetX, e.offsetY);
        e.preventDefault();
    };
    playerElement.onmouseup = function (e) {
        emitMouseUp(e.button, e.offsetX, e.offsetY);
        e.preventDefault();
    };
    playerElement.oncontextmenu = function (e) {
        emitMouseUp(e.button, e.offsetX, e.offsetY);
        e.preventDefault();
    };
    if ("onmousewheel" in playerElement) {
        playerElement.onmousewheel = function (e) {
            emitMouseWheel(e.wheelDelta, e.offsetX, e.offsetY);
            e.preventDefault();
        };
    } else {
        playerElement.addEventListener(
            "DOMMouseScroll",
            function (e) {
                emitMouseWheel(e.detail * -120, e.offsetX, e.offsetY);
                e.preventDefault();
            },
            false
        );
    }
    playerElement.pressMouseButtons = function (e) {
        pressMouseButtons(e.buttons, e.offsetX, e.offsetY);
    };
    playerElement.releaseMouseButtons = function (e) {
        releaseMouseButtons(e.buttons, e.offsetX, e.offsetY);
    };
}
function registerTouchEvents(playerElement) {
    let fingers = [9, 8, 7, 6, 5, 4, 3, 2, 1, 0];
    let fingerIds = {};
    function rememberTouch(touch) {
        let finger = fingers.pop();
        if (finger === undefined) {
            console.log("exhausted touch indentifiers");
        }
        fingerIds[touch.identifier] = finger;
    }
    function forgetTouch(touch) {
        fingers.push(fingerIds[touch.identifier]);
        delete fingerIds[touch.identifier];
    }
    function emitTouchData(type, touches) {
        let data = new DataView(new ArrayBuffer(2 + 7 * touches.length));
        data.setUint8(0, type);
        data.setUint8(1, touches.length);
        let byte = 2;
        for (let t = 0; t < touches.length; t++) {
            let touch = touches[t];
            let x = touch.clientX - playerElement.offsetLeft;
            let y = touch.clientY - playerElement.offsetTop;
            if (print_inputs) {
                console.log(`F${fingerIds[touch.identifier]}=(${x}, ${y})`);
            }
            let coord = normalizeAndQuantizeUnsigned(x, y);
            data.setUint16(byte, coord.x, true);
            byte += 2;
            data.setUint16(byte, coord.y, true);
            byte += 2;
            data.setUint8(byte, fingerIds[touch.identifier], true);
            byte += 1;
            data.setUint8(byte, 255 * touch.force, true);
            byte += 1;
            data.setUint8(byte, coord.inRange ? 1 : 0, true);
            byte += 1;
        }
        sendInputData(data.buffer);
    }
    if (inputOptions.fakeMouseWithTouches) {
        let finger = undefined;
        playerElement.ontouchstart = function (e) {
            if (finger === undefined) {
                let firstTouch = e.changedTouches[0];
                finger = { id: firstTouch.identifier, x: firstTouch.clientX - playerElementClientRect.left, y: firstTouch.clientY - playerElementClientRect.top };
                playerElement.onmouseenter(e);
                emitMouseDown(MouseButton.MainButton, finger.x, finger.y);
            }
            e.preventDefault();
        };
        playerElement.ontouchend = function (e) {
            for (let t = 0; t < e.changedTouches.length; t++) {
                let touch = e.changedTouches[t];
                if (touch.identifier === finger.id) {
                    let x = touch.clientX - playerElementClientRect.left;
                    let y = touch.clientY - playerElementClientRect.top;
                    emitMouseUp(MouseButton.MainButton, x, y);
                    playerElement.onmouseleave(e);
                    finger = undefined;
                    break;
                }
            }
            e.preventDefault();
        };
        playerElement.ontouchmove = function (e) {
            for (let t = 0; t < e.touches.length; t++) {
                let touch = e.touches[t];
                if (touch.identifier === finger.id) {
                    let x = touch.clientX - playerElementClientRect.left;
                    let y = touch.clientY - playerElementClientRect.top;
                    emitMouseMove(x, y, x - finger.x, y - finger.y);
                    finger.x = x;
                    finger.y = y;
                    break;
                }
            }
            e.preventDefault();
        };
    } else {
        playerElement.ontouchstart = function (e) {
            for (let t = 0; t < e.changedTouches.length; t++) {
                rememberTouch(e.changedTouches[t]);
            }
            if (print_inputs) {
                console.log("touch start");
            }
            emitTouchData(MessageType.TouchStart, e.changedTouches);
            e.preventDefault();
        };
        playerElement.ontouchend = function (e) {
            if (print_inputs) {
                console.log("touch end");
            }
            emitTouchData(MessageType.TouchEnd, e.changedTouches);
            for (let t = 0; t < e.changedTouches.length; t++) {
                forgetTouch(e.changedTouches[t]);
            }
            e.preventDefault();
        };
        playerElement.ontouchmove = function (e) {
            if (print_inputs) {
                console.log("touch move");
            }
            emitTouchData(MessageType.TouchMove, e.touches);
            e.preventDefault();
        };
    }
}
function isKeyCodeBrowserKey(keyCode) {
    return (keyCode >= 112 && keyCode <= 123) || keyCode === 9;
}
const SpecialKeyCodes = { BackSpace: 8, Shift: 16, Control: 17, Alt: 18, RightShift: 253, RightControl: 254, RightAlt: 255 };
function getKeyCode(e) {
    if (e.keyCode === SpecialKeyCodes.Shift && e.code === "ShiftRight") return SpecialKeyCodes.RightShift;
    else if (e.keyCode === SpecialKeyCodes.Control && e.code === "ControlRight") return SpecialKeyCodes.RightControl;
    else if (e.keyCode === SpecialKeyCodes.Alt && e.code === "AltRight") return SpecialKeyCodes.RightAlt;
    else return e.keyCode;
}
function registerKeyboardEvents() {
    document.onkeydown = function (e) {
        if (print_inputs) {
            console.log(`key down ${e.keyCode}, repeat = ${e.repeat}`);
        }
        sendInputData(new Uint8Array([MessageType.KeyDown, getKeyCode(e), e.repeat]).buffer);
        activeKeys.push(getKeyCode(e));
        if (e.keyCode === SpecialKeyCodes.BackSpace) {
            document.onkeypress({ charCode: SpecialKeyCodes.BackSpace });
        }
        if (inputOptions.suppressBrowserKeys && isKeyCodeBrowserKey(e.keyCode)) {
            e.preventDefault();
        }
    };
    document.onkeyup = function (e) {
        if (print_inputs) {
            console.log(`key up ${e.keyCode}`);
        }
        sendInputData(new Uint8Array([MessageType.KeyUp, getKeyCode(e)]).buffer);
        if (inputOptions.suppressBrowserKeys && isKeyCodeBrowserKey(e.keyCode)) {
            e.preventDefault();
        }
    };
    document.onkeypress = function (e) {
        if (print_inputs) {
            console.log(`key press ${e.charCode}`);
        }
        let data = new DataView(new ArrayBuffer(3));
        data.setUint8(0, MessageType.KeyPress);
        data.setUint16(1, e.charCode, true);
        sendInputData(data.buffer);
    };
}
function onExpandOverlay_Click() {
    let overlay = document.getElementById("overlay");
    overlay.classList.toggle("overlay-shown");
}
function start() {
    let qualityStatus = document.getElementById("qualityStatus");
    if (qualityStatus) {
        qualityStatus.className = "grey-status";
    }
    let statsDiv = document.getElementById("stats");
    if (statsDiv) {
        statsDiv.innerHTML = "Not connected";
    }
    if (!connect_on_load || is_reconnection) {
        showConnectOverlay();
        invalidateFreezeFrameOverlay();
        shouldShowPlayOverlay = true;
        resizePlayerStyle();
    } else {
        connect();
    }
}
function connect() {
    "use strict";
    window.WebSocket = window.WebSocket || window.MozWebSocket;
    if (!window.WebSocket) {
        alert("Your browser doesn't support WebSocket");
        return;
    }
    ws = new WebSocket(webrtc.videoSocket);
    ws.onmessage = function (event) {
        let msg = JSON.parse(event.data);
        if (msg.type === "config") {
            onConfig(msg);
        } else if (msg.type === "playerCount") {
        } else if (msg.type === "offer") {
            onWebRtcOffer(msg);
        } else if (msg.type === "answer") {
            onWebRtcAnswer(msg);
        } else if (msg.type === "iceCandidate") {
            onWebRtcIce(msg.candidate);
        } else if (msg.type === "warning" && msg.warning) {
            console.warn(msg.warning);
        } else {
            console.warn("Invalid SS message type", msg.type);
        }
    };
    ws.onerror = function (event) {
        console.log(`WS error: ${JSON.stringify(event)}`);
    };
    ws.onclose = function (event) {
        console.log(`WS closed: ${JSON.stringify(event.code)} - ${event.reason}`);
        ws = undefined;
        is_reconnection = true;
        let playerDiv = webrtc.dom;
        console.log("playerDiv111", webRtcPlayerObj, playerDiv);
        if (webRtcPlayerObj) {
            playerDiv.removeChild(webRtcPlayerObj.video);
            webRtcPlayerObj.close();
            webRtcPlayerObj = undefined;
        }
        console.log("playerDiv222", webRtcPlayerObj, playerDiv);
        showTextOverlay(`Disconnected: ${event.reason}`);
        let reclickToStart = setTimeout(start, 4e3);
    };
}
function onConfig(config) {
    let playerDiv = webrtc.dom;
    console.log(webrtc, 1112);
    let playerElement = setupWebRtcPlayer(playerDiv, config);
    resizePlayerStyle();
    switch (inputOptions.controlScheme) {
        case ControlSchemeType.HoveringMouse:
            registerHoveringMouseEvents(playerElement);
            break;
        case ControlSchemeType.LockedMouse:
            registerLockedMouseEvents(playerElement);
            break;
        default:
            console.log(`ERROR: Unknown control scheme ${inputOptions.controlScheme}`);
            registerLockedMouseEvents(playerElement);
            break;
    }
}
function load() {
    is_reconnection = false;
    setupHtmlEvents();
    setupFreezeFrameOverlay();
    start();
}
function clearFreezeFrameOverlay() {
    let element = document.getElementById("freezeFrameOverlay");
    element.remove();
}
function close() {
    if (ws) {
        ws.close();
    }
}
var temp = new webRtcPlayer({});
var webrtc = { dom: "", videoSocket: "", load: load, close: close, webRtcPlayer: temp, resizePlayer: resizePlayerStyle, emitUIInter: emitUIInteraction };
let signalling_webSocket = null;
const copyProperties = (target, source) => {
    Object.getOwnPropertyNames(source).forEach(prop => {
        if (!prop.match(/^(?:constructor|prototype|arguments|name)/)) {
            Object.defineProperty(target, prop, Object.getOwnPropertyDescriptor(source, prop));
        }
    });
};
const Mixins = (BaseClass, ...mixins) => {
    class Base extends BaseClass {
        constructor(...props) {
            super(...props);
        }
    }
    mixins.forEach(mixin => {
        copyProperties(Base, mixin);
        copyProperties(Base.prototype, mixin.prototype);
    });
    return Base;
};
const Camera$1 = class Camera {
    constructor() {}
    addCamera() {
        this.sendWebSocketArray("addCamera", arguments[0], arguments[1]);
    }
    setCameraInfo() {
        this.sendWebSocketObj("setCameraInfo", arguments[0], arguments[1]);
    }
    getCameraInfo() {
        this.sendWebSocketObj("getCameraInfo", arguments[0], arguments[1]);
    }
    getCameraList() {
        this.sendWebSocketObj("getCameraList", arguments[0], arguments[1]);
    }
    switchCamera() {
        this.sendWebSocketObj("switchCamera", arguments[0], arguments[1]);
    }
    setCameraLimit() {
        this.sendWebSocketObj("setCameraLimit", arguments[0], arguments[1]);
    }
    rotateCurrentCamera() {
        this.sendWebSocketObj("rotateCurrentCamera", arguments[0], arguments[1]);
    }
    moveCameraByStep() {
        this.sendWebSocketObj("moveCameraByStep", arguments[0], arguments[1]);
    }
    setCameraRoaming() {
        this.sendWebSocketObj("setCameraRoaming", arguments[0], arguments[1]);
    }
    setCameraState() {
        this.sendWebSocketObj("setCameraState", arguments[0], arguments[1]);
    }
    removeCamera() {
        this.sendWebSocketObj("removeCamera", arguments[0], arguments[1]);
    }
};
const Model$1 = class Model {
    constructor() {}
    addAssetModel() {
        this.sendWebSocketArray("addAssetModel", arguments[0], arguments[1]);
    }
    addCustomModels() {
        this.sendWebSocketObj("addCustomModels", arguments[0], arguments[1]);
    }
    removeAssetModel() {
        this.sendWebSocketObj("removeAssetModel", arguments[0], arguments[1]);
    }
    removeAllAssetModel() {
        this.sendWebSocketObj("removeAllAssetModel", arguments[0], arguments[1]);
    }
    moveObjectAlongExistingPath() {
        this.sendWebSocketObj("moveObjectAlongExistingPath", arguments[0], arguments[1]);
    }
    removeObjectAlongExistingPath() {
        this.sendWebSocketObj("removeObjectAlongExistingPath", arguments[0], arguments[1]);
    }
    setMoveModel() {
        this.sendWebSocketObj("setMoveModel", arguments[0], arguments[1]);
    }
    removeMoveModel() {
        this.sendWebSocketObj("removeMoveModel", arguments[0], arguments[1]);
    }
};
const Marker$1 = class Marker {
    addCustomMarkers() {
        this.sendWebSocketObj("addCustomMarkers", arguments[0], arguments[1]);
    }
    addMarkers() {
        this.sendWebSocketObj("addMarkers", arguments[0], arguments[1]);
    }
    removeMarkers() {
        this.sendWebSocketObj("removeMarkers", arguments[0], arguments[1]);
    }
    removeMarkersAll() {
        this.sendWebSocketObj("removeMarkersAll", arguments[0], arguments[1]);
    }
    addPaths() {
        this.sendWebSocketObj("addPaths", arguments[0], arguments[1]);
    }
    removePaths() {
        this.sendWebSocketObj("removePaths", arguments[0], arguments[1]);
    }
    removePathsAll() {
        this.sendWebSocketObj("removePathsAll", arguments[0], arguments[1]);
    }
    addPolygons() {
        this.sendWebSocketObj("addPolygons", arguments[0], arguments[1]);
    }
    removePolygons() {
        this.sendWebSocketObj("removePolygons", arguments[0], arguments[1]);
    }
    removePolygonsAll() {
        this.sendWebSocketObj("removePolygonsAll", arguments[0], arguments[1]);
    }
};
const GisLayer$1 = class GisLayer {
    addGisLayer() {
        this.sendWebSocketObj("addGisLayer", arguments[0], arguments[1]);
    }
};
const TwinScenario$1 = class TwinScenario {
    simCrossTrafficParticipant() {
        this.sendWebSocketObj("simCrossTrafficParticipant", arguments[0], arguments[1]);
    }
    simCrossTrafficLight() {
        this.sendWebSocketObj("simCrossTrafficLight", arguments[0], arguments[1]);
    }
    removeSimCrossTrafficParticipant() {
        this.sendWebSocketObj("removeSimCrossTrafficParticipant", arguments[0], arguments[1]);
    }
    removeSimCrossTrafficLight() {
        this.sendWebSocketObj("removeSimCrossTrafficLight", arguments[0], arguments[1]);
    }
};
const Diagram$1 = class Diagram {
    addHeatMap() {
        this.sendWebSocketObj("addHeatMap", arguments[0], arguments[1]);
    }
    removeHeatMap() {
        this.sendWebSocketObj("removeHeatMap", arguments[0], arguments[1]);
    }
    addRoadHeatMap() {
        this.sendWebSocketObj("addRoadHeatMap", arguments[0], arguments[1]);
    }
    removeRoadHeatMap() {
        this.sendWebSocketObj("removeRoadHeatMap", arguments[0], arguments[1]);
    }
};
const Custom$1 = class Custom {
    performExtendAction() {
        this.sendWebSocketObj("performExtendAction", arguments[0], arguments[1]);
    }
    addGlobalEventHandler() {
        this.sendWebSocketObj("addGlobalEventHandler", arguments[0], arguments[1]);
    }
};
const Control$1 = class Control {
    startGetCoord() {
        this.sendWebSocketObj("startGetCoord", arguments[0], arguments[1]);
    }
    stopGetCoord() {
        this.sendWebSocketObj("stopGetCoord", arguments[0], arguments[1]);
    }
    UEgeoInfo() {
        this.sendWebSocketObj("UEgeoInfo", arguments[0], arguments[1]);
    }
};
const Scene$1 = class Scene extends Mixins(Marker$1, Camera$1, Model$1, GisLayer$1, TwinScenario$1, Diagram$1, Control$1, Custom$1) {
    constructor(dom, options, callback) {
        super();
        this.dom = dom;
        this.consoleObj = {};
        this.timerInterval = null;
        window.addEventListener("beforeunload", event => {
            this.closeClientWebsocket();
        });
        this.signallingWebSocket = signalling_webSocket = new WebSocketClient({ url: options.signallingSocket });
        if (options.renderType != "UnrealEngine") {
            console.warn(`%c ➡️➡️➡️ %c 请设置正确的渲染类型 %c`, "background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff", "background:#f56c6c ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff", "background:transparent");
            return;
        }
        this.timerInterval = setInterval(() => {
            if (!signalling_webSocket.websocketMessagePromise.initFirstWebsocket) {
                return;
            }
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
                this.timerInterval = null;
            }
            if (this.signallingWebSocket.streamRes.streamCode == "500" || this.signallingWebSocket.streamRes.streamCode == "501") {
                console.warn(
                    `%c ➡️➡️➡️ %c ${this.signallingWebSocket.streamRes.streamMessage} %c`,
                    "background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff",
                    "background:#f56c6c ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff",
                    "background:transparent"
                );
                return;
            }
            if (this.signallingWebSocket.streamRes.streamCode == "0") {
                console.log(`%c ➡️➡️➡️ %c 开启视频渲染 %c`, "background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff", "background:#41b883 ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff", "background:transparent");
                this.initPlay(options, this.signallingWebSocket.streamRes.streamUrl, callback);
            }
        }, 10);
    }
    closeClientWebsocket() {
        if (this.signallingWebSocket) {
            this.signallingWebSocket.closeWebsocket();
            this.signallingWebSocket = null;
        }
        console.log("关闭信令websocket");
    }
    closeClientPlayer() {
        if (webrtc) {
            webrtc.close();
        }
        console.log("关闭视频渲染");
    }
    closeClient() {
        this.closeClientWebsocket();
        this.closeClientPlayer();
    }
    initPlay(options, url, callback) {
        webrtc.dom = this.dom;
        webrtc.videoSocket = url;
        webrtc.load();
        setTimeout(() => {
            this.initMap(options, callback);
        }, 500);
    }
    initMap() {
        this.sendWebSocketObj("initMap", arguments[0], arguments[1]);
    }
    sendWebSocketObj(commandName, options, callback) {
        let obj = null;
        if (Object.prototype.toString.call(options) === "[object Object]") {
            obj = { command: commandName, param: { ...options } };
            if (Object.prototype.toString.call(callback) === "[object Function]") {
                signalling_webSocket.websocketMessagePromise[commandName] = callback;
            }
        } else {
            obj = { command: commandName, param: {} };
            if (Object.prototype.toString.call(options) === "[object Function]") {
                signalling_webSocket.websocketMessagePromise[commandName] = options;
            }
        }
        this.consoleObj = obj;
        signalling_webSocket.sendMessage(obj);
        if (callback) {
            callback(true);
        }
    }
    sendWebSocketArray(commandName, options, callback) {
        let obj = { command: commandName, param: [] };
        if (Array.isArray(options)) {
            options.forEach(item => {
                obj.param.push({ ...item });
            });
        } else {
            obj.param = [{ ...options }];
        }
        signalling_webSocket.websocketMessagePromise[commandName] = callback;
        this.consoleObj = obj;
        signalling_webSocket.sendMessage(obj);
    }
};
class WebSocketClient {
    constructor(val) {
        this.websocket = null;
        this.websocketUrl = val.url;
        this.status = null;
        this.lockReconnect = true;
        this.websocketMessage = null;
        this.websocketTimer = null;
        this.websocketMessagePromise = { initFirstWebsocket: null };
        this.streamRes = { streamCode: null, streamUrl: null, streamMessage: null };
        this.initWebSocket();
    }
    initWebSocket() {
        this.websocket = new WebSocket(this.websocketUrl);
        this.websocket.onopen = () => {
            this.status = "open";
        };
        this.websocket.onerror = () => {
            console.log("this.websocket-onerror");
            this.closeHandle();
        };
        this.websocket.onclose = () => {
            console.log("this.websocket-onclose");
            this.closeHandle();
        };
        this.websocket.onmessage = event => {
            if (event && event.data == "heartbeat") {
                return;
            }
            const msg = JSON.parse(event.data);
            if (msg.data.code && msg.data.message) {
                this.streamRes.streamCode = msg.data.code;
                this.streamRes.streamMessage = msg.data.message;
                this.websocketMessagePromise["initFirstWebsocket"] = this.streamRes;
                if (msg.data.code == 0) {
                    this.streamRes.streamUrl = msg.data.streamUrl;
                }
            }
            sessionStorage.setItem("token", msg.clientId);
            const key = msg.data.command; //camera
            if (!key || key == 0) return;
            this.websocketMessage = JSON.stringify(msg);
            if (typeof this.websocketMessagePromise[key] === "function") {
                this.websocketMessagePromise[key](msg.data);
                // this.websocketMessagePromise.camera(msg.data)
            }
        };
    }
    closeHandle() {
        if (this.status !== "close") {
            console.warn(
                `%c ➡️➡️➡️ %c '网络不稳定断开进行重连' %c`,
                "background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff",
                "background:#f56c6c ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff",
                "background:transparent"
            );
            if (!this.lockReconnect) {
                return;
            }
            this.lockReconnect = false;
            this.websocketTimer = setTimeout(() => {
                this.initWebSocket();
                this.lockReconnect = true;
                clearTimeout(this.websocketTimer);
            }, 1e3);
        }
    }
    closeWebsocket() {
        console.log("手动关闭websocket");
        this.status = "close";
        if (this.websocket) {
            this.websocket.close();
            this.websocket = null;
        }
        if (this.websocketTimer) {
            clearTimeout(this.websocketTimer);
        }
    }
    uuid4() {
        let temp_url = URL.createObjectURL(new Blob());
        let uuid = temp_url.toString();
        URL.revokeObjectURL(temp_url);
        return uuid.split(/[:/]/g).pop().toLowerCase();
    }
    sendMessage(data) {
        let parm = { type: 1, source: 2, msgId: this.uuid4(), timestamp: new Date().getTime(), clientId: sessionStorage.getItem("token"), commandId: data.command, data: data };
        console.log("信令发送", parm);
        this.websocket.send(JSON.stringify(parm));
    }
}
const CloudRender = { Scene: Scene$1 };

export default CloudRender;
